import React from "react"
import { renderHTML } from "../../agility/utils"
import {
  InfoRowContainer,
  Wrapper,
  SliderContainer,
  Slide,
  SliderArrow,
} from "./styles"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const InfoRow = ({ item }) => {
  const LeftArrow = props => {
    const { onClick } = props
    return (
      <SliderArrow>
        <FaChevronLeft onClick={onClick} />
      </SliderArrow>
    )
  }
  const RightArrow = props => {
    const { onClick } = props
    return (
      <SliderArrow>
        <FaChevronRight onClick={onClick} />
      </SliderArrow>
    )
  }

  const settings = {
    dots: false,
    infinite: true,
    prevArrow: <LeftArrow />,
    nextArrow: <RightArrow />,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  }
  return (
    <InfoRowContainer>
      <Wrapper>
        <h3>{item.customFields.title}</h3>

        <SliderContainer>
          <Slider {...settings}>
            <Slide>
              <img
                src={item.customFields.icon1.url}
                alt={item.customFields.icon1.label}
              />
              <h5>{item.customFields.icon1Title}</h5>
              <div
                dangerouslySetInnerHTML={renderHTML(
                  item.customFields.icon1Text
                )}
              ></div>
            </Slide>
            <Slide>
              <img
                src={item.customFields.icon2.url}
                alt={item.customFields.icon2.label}
              />
              <h5>{item.customFields.icon2Title}</h5>
              <div
                dangerouslySetInnerHTML={renderHTML(
                  item.customFields.icon2Text
                )}
              ></div>
            </Slide>
            <Slide>
              <img
                src={item.customFields.icon3.url}
                alt={item.customFields.icon3.label}
              />
              <h5>{item.customFields.icon3Title}</h5>
              <div
                dangerouslySetInnerHTML={renderHTML(
                  item.customFields.icon3Text
                )}
              ></div>
            </Slide>
            <Slide>
              <img
                src={item.customFields.icon4.url}
                alt={item.customFields.icon4.label}
              />
              <h5>{item.customFields.icon4Title}</h5>
              <div
                dangerouslySetInnerHTML={renderHTML(
                  item.customFields.icon4Text
                )}
              ></div>
            </Slide>
            <Slide>
              <img
                src={item.customFields.icon5.url}
                alt={item.customFields.icon5.label}
              />
              <h5>{item.customFields.icon5Title}</h5>
              <div
                dangerouslySetInnerHTML={renderHTML(
                  item.customFields.icon5Text
                )}
              ></div>
            </Slide>
          </Slider>
        </SliderContainer>
      </Wrapper>
    </InfoRowContainer>
  )
}

export default InfoRow
